import { apiUrl } from '../config';

const TOKEN_KEY = 'sg_auth_token';

export function getToken() {
    return sessionStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
    sessionStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
    sessionStorage.removeItem(TOKEN_KEY);
}

/**
 * Authenticated fetch wrapper
 * Attaches Bearer token, dispatches 'auth:expired' on 401, throws on 429
 */
export async function authenticatedFetch(endpoint, options = {}) {
    const url = endpoint.startsWith('http') ? endpoint : `${apiUrl}${endpoint}`;
    const token = getToken();
    const isFormData = options.body instanceof FormData;

    const mergedOptions = {
        ...options,
        headers: {
            ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
            ...(options.headers || {}),
        },
    };

    const response = await fetch(url, mergedOptions);

    if (response.status === 401) {
        window.dispatchEvent(new Event('auth:expired'));
        throw new Error('Session expired. Please sign in again.');
    }

    if (response.status === 429) {
        throw new Error('Too many requests. Please try again later.');
    }

    return response;
}
